import { defineMessages } from 'react-intl-next';

export default defineMessages({
    signUpSubTitle: {
        defaultMessage: 'Sign up to continue',
        description: 'sign up form sub title',
        id: 'cv.unified.sign.up.sub.title',
    },
    emailLabelAndPlaceholder: {
        defaultMessage: 'Email address',
        description: 'Placeholder and label for signup email field',
        id: 'cv.unified.sign.up.page.email.placeholder.and.label',
    },
    signupButtonLabel: {
        defaultMessage: 'Sign up with password',
        description: 'label for signup button',
        id: 'cv.unified.sign.up.send.link.button.text',
    },
    continueWithSingleSignOnButton: {
        defaultMessage: 'Continue with single sign-on',
        description: 'The redirect button text for customer account login using single sign-on',
        id: 'cv.unified.sign.up.continue.with.sso.button.text',
    },
    continueWithSingleSignOnDisclaimer: {
        defaultMessage: 'By continuing, you agree to the {privacyPolicyLink} and this {noticeAndDisclaimerLink}.',
        description: 'Disclaimer message shown when SSO is an available sign up method',
        id: 'cv.unified.sign.up.continue.with.sso.disclaimer.text',
    },
    privacyPolicyLinkText: {
        defaultMessage: 'Privacy Policy',
        description: 'Privacy Policy link shown on the SSO disclaimer message',
        id: 'cv.unified.sign.up.continue.with.sso.privacy.policy.link.text',
    },
    noticeAndDisclaimerLinkText: {
        defaultMessage: 'Notice and Disclaimer',
        description: 'Disclaimer message shown when SSO is an available sign up method',
        id: 'cv.unified.sign.up.continue.with.sso.notice.and.disclaimer.link.text',
    },
    documentTitle: {
        defaultMessage: 'Sign up for an account',
        description: 'Title of the sign up page',
        id: 'cv.unified.sign.up.document.title',
    },
    backButtonLabel: {
        defaultMessage: 'Back',
        description: 'title for the back button',
        id: 'cv.unified.sign.up.back.button.label',
    },
});
